import {Component, Injector} from '@angular/core';
import {GeneralChartComponent, high_colors} from "../general-chart/general-chart.component";
import { HighchartsChartComponent } from "highcharts-angular";
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-stress-drawdown-chart',
  templateUrl: '../general-chart/general-chart.component.html',
  imports: [HighchartsChartComponent, CommonModule],
  standalone: true,
})
export class StressDrawdownChartComponent extends GeneralChartComponent {

  constructor(injector: Injector) {
    super(injector);
    this.chartConstructor = 'chart';
  }

  initChart() {
    this.chartOptions = {
      chart: {
        height: '620px'
      },
      credits: {
        enabled: false
      },
      title: {
        text: ''
      },
      legend: {
        maxHeight: 80,
        itemDistance: 5,
        margin: 0,
        padding: 0,
        itemWidth: 100,
        backgroundColor: 'transparent'
      },
      colors: high_colors,
      xAxis: {
        minorGridLineWidth: 0,
        gridLineWidth: 0,
        labels: {
          enabled: false
        },
        title: {
          text: 'Assets',
          style: {
            textTransform: 'capitalize'
          }
        }
      },
      yAxis: {
        minorGridLineWidth: 0,
        labels: {
          format: '{value}%'
        },
        title: {
          text: 'Drawdown',
          style: {
            textTransform: 'capitalize'
          }
        }
      },
      series: this.series,
      plotOptions: {
        series: {
          lineWidth: 2,
          dataGrouping: {
            enabled: false
          },
          tooltip: {
            pointFormat: '{series.name}: <b>{point.y}%</b>',
          },
        },
        column: {
          dataLabels: {
            enabled: true,
            format: '{y}%'
          }
        },
        scatter: {
          dataLabels: {
            enabled: true,
            format: "{point.name}",
          }
        }
      },
    };
    if (this.fullHeight) {
      this.chartOptions.chart.height = '88%';
    }
    setTimeout(() => { this.loaded.set(true); });
  }

}
